import { render, staticRenderFns } from "./cart.vue?vue&type=template&id=4a6b6a70&scoped=true&"
import script from "./cart.vue?vue&type=script&lang=js&"
export * from "./cart.vue?vue&type=script&lang=js&"
import style0 from "./cart.vue?vue&type=style&index=0&id=4a6b6a70&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6b6a70",
  null
  
)

export default component.exports